import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: ('spedflow-admin' | 'tenant-admin' | 'advocate' | 'client')[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, loading, isSpedflowAdmin, isTenantAdmin, isAdvocate, isClient } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles) {
    const hasAccess = allowedRoles.some((role) => {
      switch (role) {
        case 'spedflow-admin':
          return isSpedflowAdmin;
        case 'tenant-admin':
          return isTenantAdmin;
        case 'advocate':
          return isAdvocate;
        case 'client':
          return isClient;
        default:
          return false;
      }
    });

    if (!hasAccess) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
}
